import sidebar from '../services/sidebar';

export default (el) => {
  el.onclick = () => setTimeout(() => {
    sidebar.close();
  }, 100);
};
